import { Injectable, Signal, WritableSignal, signal } from '@angular/core';
import { Progress } from '../models/interfaces/progress.interface';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
  protected _progress: WritableSignal<Progress[]> = signal([]);

  public get progress(): Signal<Progress[]> {
    return this._progress;
  }

  public new(progress: Progress): void {
    this._progress.update(items => [...items, progress]);
  }

  public remove(key: string): void {
    this._progress.update(items => items.filter(item => item.key !== key));
  }

  public update(key: string, progress: Partial<Progress>): void {
    this._progress.update(items => items.map(item => (item.key === key ? { ...item, ...progress } : item)));
  }
}
